var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountSelectedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6976 19.386C14.7768 20.1053 18.6668 17.3816 19.386 13.3023C20.1053 9.22314 17.3816 5.3332 13.3024 4.61393C9.22314 3.89465 5.33321 6.61842 4.61393 10.6976C3.89466 14.7768 6.61842 18.6668 10.6976 19.386ZM10.4372 20.8633C15.3322 21.7264 20.0001 18.4579 20.8633 13.5628C21.7264 8.66777 18.4579 3.99985 13.5628 3.13672C8.66778 2.27359 3.99985 5.5421 3.13672 10.4372C2.27359 15.3322 5.54211 20.0001 10.4372 20.8633Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.90171 15.9281C3.81317 15.7459 3.85159 15.528 3.99709 15.3871C5.99948 13.4482 8.87153 12.4638 11.8263 12.9848C14.7811 13.5058 17.1433 15.4132 18.3618 17.92C18.4503 18.1021 18.4119 18.32 18.2664 18.4609C16.264 20.3998 13.392 21.3843 10.4372 20.8633C7.48236 20.3422 5.1202 18.4349 3.90171 15.9281Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4754 9.56651C15.1876 11.1982 13.6317 12.2877 12 12C10.3683 11.7123 9.2788 10.1563 9.56651 8.52462C9.85422 6.89294 11.4102 5.80343 13.0419 6.09114C14.6736 6.37885 15.7631 7.93482 15.4754 9.56651Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSelectedIcon);
export default __webpack_public_path__ + "static/media/AccountSelectedIcon.2b9de3052a8ade2f0b0bf46c8900d645.svg";
export { ForwardRef as ReactComponent };